import React, { useEffect, useState, createContext } from 'react'
import { allTokens as allTokensJson } from 'lottery/constants'

export const TokenContext = createContext({
  allTokens: null,
})

const TokenProvider = ({ children }) => {
  const [allTokens, setAllTokens] = useState(null)
  const chainId = parseInt(process.env.REACT_APP_CHAIN_ID)

  useEffect(() => {
    allTokensJson.tokens = allTokensJson.tokens.filter(
      (t) => t.chainId === chainId
    )
    setAllTokens(allTokensJson)
  }, [])

  return (
    <TokenContext.Provider value={{ allTokens }}>
      {children}
    </TokenContext.Provider>
  )
}

export default TokenProvider
